import { createFileRoute } from '@tanstack/react-router';
import { SeoAuditsPage } from '@/pages/SeoAuditsPage';

export const Route = createFileRoute('/_authed/seo/audits')({
  component: SeoAuditsPage,
});
